// extracted by mini-css-extract-plugin
export var createdDate = "_fp-1";
export var divider = "_fp-2";
export var headerDivider = "_fp-3";
export var messagesCard = "_fp-0";
export var messagesContainer = "_fp-7";
export var messagesContainerWrapper = "_fp-4";
export var pointerCapturingButtonBoxes = "_fp-a";
export var showLeftPanelButton = "_fp-9";
export var showMoreButton = "_fp-c";
export var showMoreButtonContainer = "_fp-b";
export var summaryTitle = "_fp-6";
export var systemMessageCardWrapper = "_fp-d";
export var topButtons = "_fp-8";
export var withPadding = "_fp-5";